import { toast } from 'react-toastify';

export const handleApiError = (error, defaultMessage) => {
  const message =
    error.response?.data?.message ||
    error.message ||
    defaultMessage ||
    "An unexpected error occurred";
  console.error(defaultMessage, error);
  toast.error(message);
  throw new Error(message);
};

export const buildIncidentReportValidationValues = (formikValues, pendingUploads = {}) => {
  const values = JSON.parse(JSON.stringify(formikValues || {}));

  if (!values.investigation) {
    values.investigation = {};
  }

  const leasePending = pendingUploads['investigation_lease'];
  const insurancePending = pendingUploads['investigation_insurance'];
  if (leasePending && !values.investigation.leaseDocument) {
    values.investigation.leaseDocument = "__pending__";
  }
  if (insurancePending && !values.investigation.insuranceDocument) {
    values.investigation.insuranceDocument = "__pending__";
  }
  return values;
};